import { Box } from '@mui/material';
import ColoredAlert from '../global/ColoredAlert';

type Props = {
  warning: { title: string; message: string } | null;
  mb?: number;
};

function CustomerScheduleBlockAlert({ warning, mb = 2 }: Props) {
  if (!warning) return null;

  return (
    <Box sx={{ mb }}>
      <ColoredAlert
        type="warning"
        title={warning.title}
        subtitle={`${warning.message} You can still schedule them as staff.`}
        dismissible={false}
        animate={false}
      />
    </Box>
  );
}

export default CustomerScheduleBlockAlert;
